import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from './pages/LandingPage';
import AdminQuotes from './pages/AdminQuotes';
import AdminGallery from './pages/AdminGallery';
import TermsOfService from './pages/TermsOfService';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin/quotes" element={<AdminQuotes />} />
          <Route path="/admin/gallery" element={<AdminGallery />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
